<h1 mat-dialog-title>Cambiar de estado</h1>

<mat-dialog-content [formGroup]="form">
  <p>Estado actual: {{ current_potential_client.potential_client_status.name }}</p>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>Nuevo estado</mat-label>
          <mat-select formControlName="potential_client_status_slug">
            @for (item of potential_client_statuses; track item) {
              <mat-option [value]="item.slug" [disabled]="item.slug === current_potential_client.potential_client_status_slug">{{
                item.name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (requiresStandbyDate) {
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Fecha de notificación</mat-label>
            <input matInput [matDatepicker]="standbyPicker" [min]="minNotifyDate" formControlName="standby_notify_at" />
            <mat-datepicker-toggle matSuffix [for]="standbyPicker"></mat-datepicker-toggle>
            <mat-datepicker #standbyPicker></mat-datepicker>
          </mat-form-field>
        </div>
      }

      @if (requiresRejection) {
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Motivo de rechazo</mat-label>
            <mat-select formControlName="rejection_reason">
              @for (reason of rejectionReasons; track reason.value) {
                <mat-option [value]="reason.value">{{ reason.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Justificación (opcional)</mat-label>
            <textarea matInput rows="3" formControlName="rejection_justification"></textarea>
          </mat-form-field>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" type="button">Cancelar</button>
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="!form.valid" type="button">
    <mat-icon style="margin-right: 10px">refresh</mat-icon>
    Actualizar estado
  </button>
</mat-dialog-actions>
